


export enum AppRoutesEnum {
	basePath = '/',
	admin = 'admin',
	article = 'article',
	about = 'o-nas',
	history = 'nase-historie',
	order = 'chci-objednat',
	orderSelect = 'chci-objednat-vyber',
	catOrder = 'chci-objednat-kocka',
	catProbe = 'chci-objednat-jicnova-sonda',
	gallery = 'galerie',
	partners = 'pro-partnery',
	partnersRegistration = 'registrace-pro-partnery',
	partnersOrder = 'objednavka-pro-partnery',
	faq = 'nejcastejsi-dotazy',
	contact = 'kontakt',
	salesNetwork = 'prodejni-sit',
	formPlaceholder = 'docasny-formular',
	thankYouOrder = 'dekujeme-za-objednavku',
	thankYouRegistration = 'dekujeme-za-registraci',
}



export enum NavigateRoutesEnum {
	basePath = AppRoutesEnum.basePath,
	admin = `/${AppRoutesEnum.admin}`,
	article = `/${AppRoutesEnum.article}`,
	about = `/${AppRoutesEnum.about}`,
	history = `/${AppRoutesEnum.history}`,
	order = `/${AppRoutesEnum.order}`,
	orderSelect = `/${AppRoutesEnum.orderSelect}`,
	catOrder = `/${AppRoutesEnum.catOrder}`,
	catProbe = `/${AppRoutesEnum.catProbe}`,
	gallery = `/${AppRoutesEnum.gallery}`,
	partners = `/${AppRoutesEnum.partners}`,
	partnersRegistration = `/${AppRoutesEnum.partnersRegistration}`,
	partnersOrder = `/${AppRoutesEnum.partnersOrder}`,
	faq = `/${AppRoutesEnum.faq}`,
	contact = `/${AppRoutesEnum.contact}`,
	salesNetwork = `/${AppRoutesEnum.salesNetwork}`,
	formPlaceholder = `/${AppRoutesEnum.formPlaceholder}`,
	thankYouOrder = `/${AppRoutesEnum.thankYouOrder}`,
	thankYouRegistration = `/${AppRoutesEnum.thankYouRegistration}`,
}